import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export type SliderRange = { minValue: number, maxValue: number };

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeSliderComponent),
      multi: true,
    },
  ],
  standalone: false,
})

export class RangeSliderComponent implements ControlValueAccessor {
  @Input() minimum = 0;
  @Input() maximum = 100;
  @Input() minDifference = 1;
  @Input() minDisplayValue?: string;
  @Input() maxDisplayValue?: string;
  @Input() hideThumbLabelText: boolean = false;
  @Input() 
  @HostBinding('class.formatted-labels')
  useFormattedLabels: boolean = false;
  @Input() labelsArray: string[] = [];
  minValue: number = 0;
  maxValue: number = 100;

  private _value: SliderRange = { minValue: 0, maxValue: 0 };
  private _disabled: boolean = false;

  get value(): SliderRange {
    return this._value;
  }

  set value(val: SliderRange) {
    if (val && (val.minValue !== this.minValue || val.maxValue !== this.maxValue)) {
      this._value = val;
      this.minValue = val.minValue;
      this.maxValue = val.maxValue;
      this.onChange(val);
      this.onTouched();
    }
  }

  writeValue(value: SliderRange): void {
    if (value) {
      this.value = { ...value };
    }
  }

  registerOnChange(fn: (value: SliderRange) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  formatLabel = (value: number): string => {
    return this.labelsArray?.[value] || value.toString();
  };

  private onChange: (value: SliderRange) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  onMinChange(minValue: number) {
    this.value = { ...this._value, minValue };
  }

  onMaxChange(maxValue: number) {
    this.value = { ...this._value, maxValue };
  }
}
